import { useState, useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useChats = () => {
  const { api, userID } = useContext(GlobalContext);

  const [chats, setChats] = useState([]);
  const [loadingChats, setLoadingChats] = useState(false);

  const [people, setPeople] = useState([]);
  const [labels, setLabels] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchChats = async (contact, pageIndex = 1) => {
    setLoadingChats(true);

    try {
      const res = await api.post("/Whatsapp/v1.0/getWhatsappConversation", {
        userid: userID,
        contact,
        secret: "",
        pageIndex: pageIndex.toString(),
        recordPerPage: "20",
      });

      const data = res.data;

      if (data?.data) {
        if (pageIndex === 1) {
          setChats([...data.data]);
        } else {
          setChats((prev) => [...data.data, ...prev]);
        }
      }

      return data;
    } catch (err) {
      console.error(err);
      return null;
    } finally {
      setLoadingChats(false);
    }
  };

  const sendMessage = async (mobile, message) => {
    try {
      const res = await api.post("/Whatsapp/sendInstantMessage", {
        userid: userID,
        message,
        contact: mobile,
        secret: "NA",
      });

      return res.data;
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const getAllUserList = async () => {
    try {
      setLoading(true);

      const res = await api.post("/User/getAllUserList", {
        userid: userID,
      });

      const data = res.data;

      if (data?.responseCode === "00") {
        setPeople(data.response || []);
      }

      return data;
    } catch (error) {
      console.error(error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  const fetchLabels = async () => {
    try {
      const res = await api.post("/Whatsapp/v1/getChatLabels", {
        userid: userID,
      });

      const result = res.data;

      if (result?.data) {
        setLabels(result.data);
      }

      return result;
    } catch (error) {
      console.error("Error fetching labels:", error);
      return null;
    }
  };

  const assignLabelToChat = async (contactInfo, labelIndex) => {
    try {
      const label = labels[labelIndex];

      const payload = {
        contactId: contactInfo.id,
        contactNumber: contactInfo.contact_number,
        userid: userID,
        label,
      };

      const res = await api.post("/Whatsapp/v1/assignLabelToChat", payload);

      return res.data;
    } catch (error) {
      console.error("Assign Label Error:", error);
      return null;
    }
  };

  const assignTeamMemberToChat = async (contactInfo, teamMemberId) => {
    try {
      const res = await api.post("/Whatsapp/v1/assignTeamMemberToChat", {
        contactId: contactInfo.id,
        teamMemberId,
        userid: userID,
      });

      return res.data;
    } catch (error) {
      console.error("Assign Team Member Error:", error);
      return null;
    }
  };

  const editContact = async (payload) => {
    try {
      const res = await api.post("/Campaign/editContact", {
        userid: userID,
        contactNumber: payload.contactNumber,
        contactName: payload.contactName,
        contactEmail: payload.contactEmail,
        gender: payload.gender,
        tags: payload.tags || [""],
      });

      return res.data;
    } catch (error) {
      console.error("Edit Contact Error:", error);
      return null;
    }
  };

  return {
    chats,
    loadingChats,
    fetchChats,
    sendMessage,

    people,
    setPeople,
    labels,

    getAllUserList,
    fetchLabels,
    editContact,
    assignLabelToChat,
    assignTeamMemberToChat,

    loading,
  };
};

export default useChats;